<template>
	<div id="app">
		<div class="main" v-touch:swipe.left="swipeLeft"  v-touch:swipe.right="swipeRight">
			<!-- <transition name="page-animation">
				<router-view @clicked="onClickChild"></router-view>
			</transition>
			<div class="links pos-bottom-right">
				<div class="pagination">
					<transition name="slide-left">
						<router-link v-if="current_wordID.prev_page" :to="current_wordID.prev_page">
							<img src="./assets/images/svg/left.svg" alt="">
						</router-link>
					</transition>
					<span class="ml-2 mr-2">{{current_wordID.page_id}}</span>
					<transition name="slide-right">
						<router-link v-if="current_wordID.next_page" :to="current_wordID.next_page">
							<img src="./assets/images/svg/right.svg" alt="">
						</router-link>
					</transition>
				</div>
				<div class="info">
					<span class="text-muted">pages</span>
				</div>
			</div> -->
			<home/>
			<skills/>
			<portfolio/>
			<contact/>
		</div>
	</div>
</template>

<script>
import contact from './pages/form'
import portfolio from './pages/portfolio'
import skills from './pages/skills'
import home from './pages/home'
export default {
	name: 'App',
	components: {
		home,
		skills,
		portfolio,
		contact
	},
	data () {
		return {
			current_wordID: [],
			current: 0,
			counter: 0,
			pages: [
				{
					link: '/'
				},
				{
					link: '/skills'
				},
				{
					link: '/portfolio'
				},
				{
					link: '/form'
				}
			]
		}
	},
	methods: {
		onClickChild (value) {
			this.current_wordID = value
		},
		scrollDown(e) {
			e = e || window.event

			var max = 3
			var min = 0
			// this.counter++
			var delta = Math.max(-1, Math.min(1, e.deltaY))
			
			if ( delta == 1 && this.counter < max ) {
				this.counter++
			} else if ( delta == -1 && this.counter > min ) {
				this.counter--
			}

			// this.$router.push({ path: this.pages[this.counter].link })

			return delta
			e.preventDefault()
		},
		swipeRight () {
			var max = 3
			var min = 0

			if ( this.counter > min ) {
				this.counter--
			}

			this.$router.push({ path: this.pages[this.counter].link })
		},
		swipeLeft () {
			var max = 3
			var min = 0

			if ( this.counter < max ) {
				this.counter++
			}

			this.$router.push({ path: this.pages[this.counter].link })
		}
	},
	beforeRouteLeave (to, from) {
		const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
		if (answer) {
			next()
		} else {
			next(false)
		}
	},
	mounted () {
		this.$nextTick ( function() {
			window.addEventListener("wheel", this.scrollDown, false)
		})
	}
}
</script>


// WEBPACK FOOTER //
// src/App.vue